export default "__VITE_ASSET__BGzcqjxM__"